import { useRef, useEffect } from "react";
import { Eraser } from "lucide-react";

export default function SignaturePad({ onChange, defaultDataUrl }) {
  const canvasRef = useRef(null);
  const drawingRef = useRef(false);
  const lastRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    if (!defaultDataUrl) return;
    const c = canvasRef.current; const ctx = c.getContext("2d");
    const img = new Image();
    img.onload = () => { ctx.drawImage(img, 0, 0, c.width, c.height); onChange(c.toDataURL("image/png")); };
    img.src = defaultDataUrl;
  }, [defaultDataUrl]); // eslint-disable-line

  const pos = (e) => {
    const c = canvasRef.current; const rect = c.getBoundingClientRect();
    const t = e.touches?.[0];
    return { x: ((t?.clientX ?? e.clientX) - rect.left) * (c.width / rect.width), y: ((t?.clientY ?? e.clientY) - rect.top) * (c.height / rect.height) };
  };
  const start = (e) => { e.preventDefault(); drawingRef.current = true; lastRef.current = pos(e); };
  const draw = (e) => {
    if (!drawingRef.current) return; e.preventDefault();
    const ctx = canvasRef.current.getContext("2d"); const p = pos(e);
    ctx.beginPath(); ctx.moveTo(lastRef.current.x, lastRef.current.y); ctx.lineTo(p.x, p.y); ctx.stroke();
    lastRef.current = p;
  };
  const end = () => { if (drawingRef.current) { drawingRef.current = false; onChange(canvasRef.current.toDataURL("image/png")); } };
  const clear = () => {
    const c = canvasRef.current; const ctx = c.getContext("2d");
    ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, c.width, c.height); onChange("");
  };

  return (
    <div className="space-y-2">
      <div className="border border-white/10 rounded-xl bg-white overflow-hidden">
        <canvas ref={canvasRef} width={600} height={180} className="w-full h-44 cursor-crosshair touch-none"
          onMouseDown={start} onMouseMove={draw} onMouseUp={end} onMouseLeave={end}
          onTouchStart={start} onTouchMove={draw} onTouchEnd={end} data-testid="vet-signature-canvas" />
      </div>
      <button type="button" onClick={clear} className="flex items-center gap-1.5 text-xs text-white/40 hover:text-white font-manrope" data-testid="vet-signature-clear">
        <Eraser className="w-3 h-3" /> Clear
      </button>
    </div>
  );
}
